import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { httpLoaderFactory, kcFactory, translationFactory } from '@core-factories';
import {
  apimInterceptor,
  httpErrorInterceptor,
  httpLoaderInterceptor,
  keycloakInterceptor,
} from '@core-interceptors';
import { KeycloakService, TranslationService } from '@core-services';
import { environment } from '@environment';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { reducers } from '@store-reducers';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        httpLoaderInterceptor,
        keycloakInterceptor,
        apimInterceptor,
        httpErrorInterceptor,
      ]),
    ),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      deps: [TranslationService],
      useFactory: translationFactory,
      multi: true,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        disableClose: true,
      },
    },
    {
      provide: APP_INITIALIZER,
      deps: [KeycloakService],
      useFactory: kcFactory,
      multi: true,
    },
    provideStore(reducers),
    provideEffects([]),
    provideStoreDevtools({
      logOnly: environment.production,
      maxAge: 25,
    }),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'always',
      },
    },
  ],
};
